import { render } from "./RecruitmentBoardCommentsPreview.vue?vue&type=template&id=f2b3a064&scoped=true"
import script from "./RecruitmentBoardCommentsPreview.vue?vue&type=script&lang=js"
export * from "./RecruitmentBoardCommentsPreview.vue?vue&type=script&lang=js"

import "./RecruitmentBoardCommentsPreview.vue?vue&type=style&index=0&id=f2b3a064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b3a064"]])

export default __exports__